module.exports = __webpack_public_path__ + "static/media/aw_mobile_hero_350_mozza_fr.ce7d227a.jpg";